import { get, postMultiPart, getImageStream } from "../../../../shared/data";

export const addImageToProduct = (shipmentKey, productKey, payload) => {
    return postMultiPart(`/receiving/shipments/${shipmentKey}/products/${productKey}/photos`, payload);
};

export const getProductImages = (shipmentKey, productKey) => {
    return get(`/receiving/shipments/${shipmentKey}/products/${productKey}/photos`);
};

export const getProductImageStreamUrl = (shipmentKey, productKey, number) => {
    return `/receiving/shipments/${shipmentKey}/products/${productKey}/photos/${number}/stream`;
};

export const streamProductImage = (shipmentKey, productKey, number) => {
    return getImageStream(getProductImageStreamUrl(shipmentKey, productKey, number));
};
